import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home'

import Categoria from '@/components/views/categoria'
import FichaNoticia from '@/components/views/ficha-noticia'

import noticias from '@/components/views/noticias';

import Contacto from '@/components/views/contacto'



import Error404 from '@/components/views/error-404'

import politicaCookies from '@/components/views/politica-de-cookies'
import politicaPrivacidad from '@/components/views/politica-de-privacidad'
import avisoLegal from '@/components/views/aviso-legal'

Vue.use(Router)


import messages from '@/translations';

let en = messages.en.enlaces;
let es = messages.es.enlaces;

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: `${es.categoria}/:id?`,
			alias: `${en.categoria}/:id?`,
			name: 'categoria',
			component: Categoria
		},
		{
			path: `${es.noticia}/:id`,
			alias: `${en.noticia}/:id`,
			name: 'actualidad-ficha',
			component: FichaNoticia
		},
		{
			path: es.noticias,
			alias: en.noticias,
			name: 'noticias',
			component: noticias
		},
		{
			path: es.contacto,
			alias: en.contacto,
			name: 'contacto',
			component: Contacto
		},
		{
			path: es.politica_privacidad,
			alias: en.politica_privacidad,
			name: 'politica-de-privacidad',
			component: politicaPrivacidad
		},
		{
			path: es.politica_cookies,
			alias: en.politica_cookies,
			name: 'politica-de-cookies',
			component: politicaCookies
		},
		{
			path: es.avisolegal,
			alias: en.avisolegal,
			name: 'aviso-legal',
			component: avisoLegal
		},
		{ path: '*', redirect: '/404' },
		{ path: "/404", component: Error404 }
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
});

import VueAnalytics from 'vue-analytics';

Vue.use(VueAnalytics, {
	id: 'UA-117270-3',
	router,
	debug: { sendHitTask: location.hostname.includes('ajusa.es') }
});

router.beforeEach((to, from, next) => {

	let meta;
	// if (!!to.meta) {
	// 	if (!!meta) {
	// 		document.title = meta.title
	// 		document.head.querySelector("[name=description]").content = meta.description;
	// 	}
	// }

	next()
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js